import { Breed } from "../../engine/entity/Breed";
import { Entity } from "../../engine/entity/Entity";
import { Actor, Stat } from "../actors/Actor";

export type Attack = {
  stamina: number;
  poise?: number;
  damage?: number;
  blocks?: number;
  stability?: number;
  strength?: number;
};

export class ItemBreed extends Breed {
  mandatory = false;
  furniture = false;
  stackLimit = 1;
  stats: any | null;
  wearable?: string;
  usable?: any;
  interact?: (actor: Actor) => Promise<void> | void;
  attacks?: { onehanded: Attack; twohanded: Attack };

  constructor(key: string, breedData: any) {
    super(key, breedData);
    this.stats = breedData.stats;
    this.wearable = breedData.wearable;
    this.furniture = breedData.furniture;
    this.mandatory = breedData.mandatory;
    this.usable = breedData.usable;
    this.interact = breedData.interact;
    this.attacks = breedData.attacks;
  }
}

export const BASIC_STATS = ["health", "stamina", "poise"] as const;

export class Item extends Entity<ItemBreed> {
  everHeld = false; //If item was ever held for loot spawn purposes
  uses: Stat | null = null;
  constructor(id: number, breed: ItemBreed, x?: number, y?: number) {
    super(id, breed, x, y);
    if (breed.usable) {
      this.uses = new Stat(breed.usable.uses, null, true);
    }
  }

  useItem(actor: Actor) {
    if (this.uses) {
      this.uses.change(-1);
      const usable = this.breed.usable;
      if (usable) {
        if (usable.consumeOnEmpty && this.uses.current <= 0) {
          actor.contains.remove(this.id);
        }
        if (usable.stats.health) {
          actor.health.change(usable.stats.health);
        }
        if (usable.stats.stamina) {
          actor.health.change(usable.stats.stamina);
        }
      }
    }
  }

  async interact(actor: Actor) {
    if (this.breed.interact) {
      await this.breed.interact(actor);
    }
  }

  applyStats(actor: Actor, fill?: boolean) {
    if (!this.breed.stats) {
      return;
    }

    BASIC_STATS.forEach((s) => {
      this.breed.stats[s] != null &&
        actor[s].adjustMax(this.breed.stats[s], fill);
    });
  }

  removeStats(actor: Actor) {
    if (!this.breed.stats) {
      return;
    }

    BASIC_STATS.forEach((s) => {
      this.breed.stats[s] != null &&
        actor[s].adjustMax(-1 * this.breed.stats[s]);
    });
  }
}
